import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { archiveApplicationFailed, archiveApplicationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* archiveApplication(action) {
  try {
    const url = `${BACKEND_URL}/resources/applications/${action.payload}/archive`;
    const dataResponse = yield makeRequest(url, {}, action, 'POST', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(archiveApplicationSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(archiveApplicationFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(archiveApplicationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
